export default {
  PersonalCenter: '个人中心',
  MemberManage: '成员管理',
  MemberGroupManage: '成员组管理',
  RightsManage: '权限管理',
  Channel: '渠道商',

  // 常用字词
  Confirm: '确认',
  Clear: '清除',
  NextPage: '下一页',
  PreviousPage: '上一页',
  PleaseSelect: '请选择',
  PleaseInput: '请输入',
  CreateTime: '创建时间',
  NoDataAvailable: '暂无数据',
  RegionSelection: '区域选择',
  Remarks: '备注',
  ContactInformation: '联系方式',
  BatchOperation: '批量操作',
  BulkApproval: '批量通过',
  BulkRejection: '批量驳回',
  Share: '分享',
  Export: '导出',
  ExportAll: '全部导出',
  ExportSelected: '勾选导出',
  Pass: '通过',
  Reject: '驳回',
  OperationSuccessful: '操作成功!',
  Attachment: '附件',
  Download: '下载',
  // 一级菜单部分
  WorkBench: '工作台',
  Project: '项目',
  Customer: '客户',
  IntelligenceManage: '情报管理',
  ClueManage: '线索管理',
  CaseManage: '案件管理',
  SettlementCenter: '结算中心',
  Tools: '工具',
  SupplierManage: '供应商管理',
  IntellectualPropertySaaS: '知识产权SaaS',

  // 二级菜单部分
  ProjectList: '项目列表',
  AndunClue: '安盾线索',
  PendingReview: '待审核',
  All: '全部',
  CluesForTesting: '线索测购',
  VendorClues: '供应商线索',
  AndunCase: '安盾案件',
  CivilCase: '民事案件',
  CriminalCase: '刑事案件',
  AdministrativeCase: '行政案件',
  VendorCase: '供应商案件',
  InvoiceManage: '开票管理',
  InvoiceList: '开票列表',
  CopyrightInfringe: '侵权监测',
  OnlineMonitor: '线上监测',
  OfflineMonitor: '线下监测',
  OwnershipSearch: '权属查询',
  PatentSearch: '专利查询',

  // 工作台部分
  DataOverview: '数据概览',
  AddNewClues: '新增线索',
  AnnualNewClues: '年度新增线索',
  MonthlyNewClues: '月度新增线索',
  units: '条',
  AddNewCase: '新增案件',
  NewCasesInTheYear: '年度新增案件',
  MonthlyNewCases: '月度新增案件',
  CaseClosed: '结案',
  AccumulatedNumberOfClosed: '累计结案数量',
  AccumulatedNumberOfClosedCasesForTheYear: '年度累计结案数量',
  CompensationPayment: '赔偿款',
  Amount: '标的额',
  CumulativeTotalAmount: '累计标的总额',
  ClueCase: '线索-案件',
  Yuan: '元',
  TotalCompensationAmount: '赔偿款总额',
  AccumulatedNumberOfCases: '累计案件数量',
  AccumulatedNumberOfclues: '累计线索数量',
  EvidencePendingEvidence: '已取证-待取证',
  CasesWithEvidenceObtained: '已取证案件量',
  CasesPendingEvidenceCollection: '待取证案件数量',
  OngoingCasesTerminatedCases: '在办案件-终止案件',
  NumberOfOngoingCases: '在办案件数量',
  NumberOfTerminatedCases: '终止案件数量',
  DataAnalysisOfInfringementMethods: '案件侵权方式数据分析',
  SalesChannelDataAnalysis: '案件销售渠道数据分析',
  ClueDataAnalysis: '线索数据分析',
  CaseDataAnalysis: '案件数据分析',
  DataStatistics: '数据统计',
  DistributionOfCluesByRegion: '线索区域分布',
  DistributionOfLawyerPopulation: '维权打假律师人数分布',
  DistributionOfOngoingCasesByRegion: '在办案件区域分布',
  AuditTrends: '审核趋势',
  Online: '线上',
  Offline: '线下',
  ClueVolume: '线索数量',
  //  项目列表部分
  Status: '状态',
  ProjectName: '项目名称',
  ProjectCycle: '项目周期',
  // 项目详情
  ProjectStatus: '项目状态',
  ProjectRemarks: '项目备注',
  ProjectOverview: '项目概况',
  IntellectualProperty: '知识产权',
  BillOfMaterials: '材料清单',
  InfringementMap: '侵权地图',
  NumberOfClues: '线索数量',
  Add: '新增',
  Delete: '删除',
  RightsNumber: '权利编号',
  RightsType: '权利类型',
  TrademarkClassification: '商标分类',
  PatentClassification: '专利分类',
  RightsHolder: '权利人',
  FileName: '文件名',
  rightTitle: '权利名称',
  statusRights: '权利状态',
  descriptionRights: '权利描述',
  CustomerData: '客户数据',
  DetailedData: '详情数据',
  // 情报管理
  Genplaceholder: '店铺名称/产品名称/举报人名称',
  InvestigationArea: '调查区域',
  InvestigationDate: '调查日期',
  AllocationStatus: '分配状态',
  AssignedTeam: '分配团队',
  ProductName: '产品名称',
  AllocationTime: '分配时间',
  StoreName: '店铺名称',
  UnitPrice: '产品单价',
  StoreAddress: '店铺地址',
  MonthlySalesVolume: '月销量',
  Reporter: '举报人',
  VerificationStatus: '核实状态',
  VerificationTime: '核实时间',
  // 线索管理
  reviewedClueSearch: '项目/店铺名称/线索编号/侵权主体',
  ChannelReviewedClueSearch: '店铺名称/线索编号',
  InfringementArea: '侵权区域',
  InvestigationTime: '调查时间',
  InfringementMethod: '侵权方式',
  ClueType: '线索类型',
  reportTime: '报备时间',
  Test: '测试',
  Serial: '编号',
  Intelligence: '情报',
  PushTime: '推送时间',
  Vendor: '销售商',
  InfringingLink: '侵权链接',
  InvestigationAddress: '调查地址',
  Manufacturer: '生产商',
  ReportTeam: '报备团队',
  ShopkeepID: '掌柜号',
  ReviewStatus: '审核状态',
  AuditTime: '审核时间',
  Approved: '审核通过',
  Rejected: '审核驳回',
  ReviewComment: '审核批注',
  Note: '便签',
  BulkExportImages: '批量导出图片',
  Yes: '是',
  No: '否',
  TestPurchase: '是否已测购',
  ReasonRejection: '驳回原因',
  // 驳回表单
  ReasonError: '驳回原因不能为空',
  ReasonReviewError: '审核原因不能为空',
  ReasonReview: '审核原因',
  notesError: '请填写备注',
  max512Error: '不能超过512个字符',
  max32Error: '不能超过32个字符',
  max16Error: '不能超过16个字符',
  NameCannot: '姓名不能为空',

  // 线索详情
  BasicInformation: '基本信息',
  InfringingProduct: '侵权产品',
  SalesVolume: '销量',
  SalesChannel: '销售渠道',
  PlatformName: '平台名称',
  BulkOperation: '起批量',
  StoreLink: '店铺链接',
  ProductLink: '产品链接',
  NoVendor: '暂无销售商',
  NoManufacturer: '暂无生产商',
  TestShop: '测购',
  TestShopImage: '测购图片',
  NoTestShop: '暂无测购信息',
  sendSamples: '是否需要寄送样品',
  courierCompany: '邮寄公司',
  trackingNumber: '邮寄单号',
  senderName: '邮寄人姓名',
  sender: '邮寄人',
  senderRegion: '邮寄人区域',
  senderFullAddress: '邮寄人详细地址',

  // 当事人信息
  EntityNature: '主体性质',
  EntityName: '主体名称',
  EntityType: '主体类型',
  EntityTag: '主体标签',
  Individual: '个人',
  EnterpriseCompany: '企业',
  proprietorship: '个体工商户',
  BusinessEntity: '经营主体',
  IDNumber: '身份证号',
  NatureBusiness: '经营性质',
  EntityRegion: '主体区域',
  OpposingPartyDetail: '对方当事人详情',
  BillingEntity: '开票主体',
  POSEntity: 'POS机主体',
  CreditCode: '信用代码',
  LegalRepresentative: '法定代表人',
  Operator: '经营者',
  BusinessRegistrationAddress: '工商登记地址',
  determinationImage: '认定依据图片',
  ManufacturerName: '生产商名称',
  determinationDescription: '认定依据描述',
  UpdateTime: '更新时间',
  BusinessChange: '工商变更',
  BusinessAnomaly: '经营异常',
  DishonestyInformation: '失信信息',
  AdministrativePenalty: '行政处罚',
  JudicialVerdict: '裁判文书',
  CourtAnnouncement: '法院公告',
  CourtHearingNotice: '开庭公告',
  Debtor: '被执行人',
  // 案件列表
  CaseSearchInput: '案件编号/对方当事人/线索编号/店铺名称/销售商/生产商',
  CaseSupplierCaseSearchInput: '案件编号/线索编号',
  CaseArea: '案件区域',
  CaseType: '案件类型',
  EvidenceStatus: '取证状态',
  Hasmanufacturer: '有无生厂商',
  SelectTime: '请选择时间',
  CaseProgress: '案件进度',
  CaseCode: '案件编号',
  OpposingParty: '对方当事人',
  CaseStatus: '案件状态',
  TerminationReason: '终止原因',

  // 案件详情
  CaseTerminated: '案件终止',
  Termination: '终止',
  Restoration: '恢复',
  ReviewTerminationApplication: '审核终止申请',
  RelatedCases: '关联案件',
  Memo: '备忘',
  HandlingTeam: '承办团队',
  CaseNote: '案件备注',
  ClueDetail: '线索详情',
  CaseEvidence: '案件证据',
  CaseProcess: '案件流程',
  CaseLog: '案件日志',
  CaseMemo: '案件备忘',
  ClueNumber: '线索编号',
  Evidence: '证据',
  EvidenceDetail: '证据详情',
  EvidenceType: '证据类型',
  NotarialEvidence: '公证书号/证据编号',
  EvidenceCollectionTime: '取证时间',
  SignatureNotarizationTime: '落款/固证时间',
  NotarialCertificateAttachment: '公证书附件',
  NoMemo: '暂无备忘信息',
  LetterRecordLawyer: '发函记录 (律师函)',
  LetterRecordComplaint: '发函记录 (线上投诉)',
  TrackingNumber: '快递单号',
  OnlineDocument: '在线文档',
  DateSendLetter: '发函时间',
  LetterContent: '发函内容',
  MethodSendingLetter: '发函方式',
  receipt: '是否收到已读回执',
  LogisticsInformation: '物流信息',
  ComplaintTime: '投诉时间',
  ComplaintWebsite: '投诉网址',
  ComplaintPlatform: '投诉平台',
  ComplaintContent: '投诉内容',
  ApplicationMaterial: '填写材料',
  MaterialDelivery: '材料寄送',
  ReasonCase: '案由',
  InfringementRights: '侵权权利',
  Attorneyatlaw: '代理律师',
  SubjectMatterLitigation: '诉讼标的',
  reasonableExpenses: '合理支出',
  JurisdictionalCourt: '管辖法院',
  AffixingPersonalSeal: '加盖私章',
  NoMoment: '暂无相关信息',
  Sender: '寄件人',
  Recipient: '收件人',
  MailingTime: '寄件时间',
  Mailing: '邮寄',
  SelfPickUp: '自取',
  MailMethod: '邮寄方式',
  CourierCompany: '快递公司',
  ContentsPackage: '快递内容',
  Received: '收到的',
  TrackShipment: '查看物流',
  SubmitDocument: '递交材料',
  litigationCoordination: '诉前联调',
  Acceptance: '受理',
  SubmissionDate: '递交材料日期',
  SubmissionMethod: '递交方式',
  receivCourt: '接受法院',
  testingPeriod: '联调时间',
  summons: '传票',
  preservation: '保全',
  publicNotice: '公告送达',
  exchangeOfEvidence: '证据交换',
  jurisdictionalObjection: '管辖异议',
  courtHearTime: '开庭时间',
  courtJurisdiction: '开庭法院',
  presidingJudge: '审判长',
  assistant: '助理',
  subpoenaAttachment: '传票附件',
  typesOfInterimMeasures: '保全类型',
  respondent: '被申请人',
  amountInterimMeasure: '保全金额',
  interimMeasureDocuments: '保全材料',
  formNotice: '公告形式',
  noticePeriod: '公告期',
  noticeExpenses: '公告费用',
  noticeMaterials: '公告材料',
  evidenceExchangeDeadline: '证据交换时间',
  location: '地点',
  participants: '参与人员',
  opposingEvidence: '对方证据',
  PlaintiffAttorney: '原告代理人',
  DefendantLegalRepresentative: '被告代理人',
  opposingPartyPresent: '对方当事人是否到场',
  trialProceeding: '庭审内容',
  courtDocuments: '庭审资料',
  JudgmentDate: '判决日期',
  dateReceipt: '签收日期',
  judgmentAmount: '判决金额',
  opposingParty: '对方承担诉讼费金额',
  excerptJudgment: '判决摘录',
  judgment: '判决书',
  judgmentResult: '判决结果',
  paymentRecord: '到款记录',
  receivableAmount: '应收金额',
  actualAmountReceived: '实收金额',
  closureDate: '结案时间',
  caseClosureMethod: '结案方式',
  accountsReceivable: '应收款',
  amountCollected: '实收款',
  caseResolutionDetail: '结案内容',
  litigationAnalysis: '诉讼分析',
  confirmationStatus: '确认状态',
  pendingConfirmation: '已确认',
  confirmed: '待确认',
  closingDocument: '结案文书',
  paymentDate: '付款时间',
  compensationAmount: '赔偿金额',
  litigationRefund: '诉讼退费',
  payingEntity: '付款主体',
  recipientPayment: '收款方',
  receiptDate: '收款时间',
  mediationParty: '调解对象',
  mediationContent: '调解内容',
  mediationAmount: '调解金额',
  auditResult: '审核结果',
  auditRemarks: '审核备注',
  mediationOutcome: '调解结果',
  mediationAgreement: '调解协议',
  mediationReview: '调解审核',
  executionCaseNumber: '执行案号',
  NoExecution: '暂无执行结果',
  filingFee: '受理费用',
  terminationExecutionDate: '终止执行日期',
  reasonTerminationExecution: '终止执行原因',
  reasonPayment: '未到款原因',
  executionAmount: '执行金额',
  appendixEnforcementOutcome: '执行结果附件',
  appendixEnforcementApplication: '申请执行附件',
  NoExecutionRequired: '不需要执行',
  partyWithdrawLawsuit: '撤诉对象',
  reasonWithdrawalLawsuit: '撤诉原因',
  attachmentSubpoena: '传票附件',
  beenApproved: '请问是否审核通过这份撤诉申请？',
  partySettlement: '和解对象',
  settlementAmount: '和解备注',
  releaseRemarks: '和解金额',
  settlementOutcome: '和解结果',
  settlementAgreement: '和解协议',
  settlementReview: '和解审核',
  beenReviewed: '请问是否审核',
  thisSettlementProposal: '这份和解方案?',
  thisSettlementMediation: '这份调解方案?',
  receivingCourt: '受理法院',
  dateAcceptance: '受理日期',
  deadlineSubmittingEvidence: '举证期限',
  to: '至',
  noticeAcceptance: '受理通知',
  paymentReceipt: '缴费票据',
  attendingLawyer: '出庭律师',
  contractedSupplier: '承办供应商',
  investigationCaseNumber: '联调案号',
  jointInvestigationPeriod: '预计联调周期',
  'case.caseDetail.381149-0': '终止凭证：',
  'case.caseDetail.381149-1': '查看凭证',
  'case.caseDetail.381149-2': '终止备注：',
  'case.caseDetail.381149-3': '终止时间：',
  'case.caseDetail.381149-4': '终止状态：',
  'case.caseDetail.381149-5': '已终止',
  'case.caseDetail.381149-6': '附件',
  // 成员管理
  AddNewMember: '新增成员',
  moreOperations: '更多操作',
  JoiningTime: '加入时间',
  AreaJurisdiction: '所属区域',
  DownloadQRCode: '下载二维码',
  DisableConfirmation: '禁用确认',
  DisableAccount: '请问是否确认禁用该成员的账号？',
  EnableConfirmation: '启用确认',
  EnableAccount: '请问是否确认启用该成员的账号？',
  MemberDetail: '成员详情',
  BusinessPermissions: '业务权限',
  CopyLink: '复制链接',
  Role: '角色',
  AccountStatus: '账号状态',
  AccountInformation: '账号信息',
  WeChatID: '微信号',
  Unbind: '解绑',
  SetPassword: '设置密码',
  ModifyAccount: '修改账号',
  editOnly: '您的账号仅可进行一次修改，如果确定修改，请填写以下信息。',
  OriginalAccount: '原账号',
  NewAccount: '新账号',
  Address: '地址',
  IsAdministrator: '是否是管理员',
  ViewDataPermission: '任务管理权限',
  RegionManagement: '区域管理权限',
  Account: '帐号',
  AccountCannot: '账号不能为空',
  password: '密码',
  PasswordCannot: '密码不能为空',
  validEmail: '请输入正确的邮箱',
  region: '地区',
  SelectAdministrator: '选择是否是管理员',
  Save: '保存',
  ReasonDisable: '禁用原因',
  ReasonErrorJinYong: '请填写禁用原因',
  // 开票管理
  InvoiceSearch: '开票申请编号/项目名称/开票单位名称',
  InvoiceDate: '开票时间',
  ApplicationDate: '申请时间',
  Applicant: '申请人',
  InvoiceNumber: '开票申请编号',
  InvoiceIssuingUnitName: '开票单位名称',
  InvoiceAmount: '开票金额',
  InvoiceType: '开票类型',
  InvoiceStatus: '开票状态',

  // 开票详情
  InvoiceInformation: '开票信息',
  CustomerName: '客户名称',
  TaxpayerIdentificationNumber: '纳税人识别号',
  PhoneNumber: '电话',
  IncomeType: '收入类型',
  AffiliatedCompany: '所属公司',
  AssociatedContract: '关联合同',
  InvoiceContent: '开票内容',
  Nature: '性质',
  InvoiceRemark: '发票备注',
  SettlementStatementInformation: '结算单信息',
  ContractDetail: '合同详情',
  ContractName: '合同名称',
  ContractNumber: '合同编号',
  Creator: '创建人',
  SigningDate: '签订日期',
  ContractValidityPeriod: '合同有效期',
  ContractType: '合同类型',
  SettlementNumber: '结算单号',
  SettlementType: '结算单类型',
  NumberOfCases: '案件数量',
  Payee: '收款人',
  RiskAgencyFeeIncludingCosts: '风险代理费(含成本)',
  CustomerAuthorizationFee: '客户授权费',
  SettlementAmount: '结算金额',
  Total: '合计',
  ProjectAffiliation: '所属项目',
  TotalSettlementAmount: '合计结算金额（乙方支付）',
  CaseInformation: '案件信息',
  CaseNumberAnHao: '案号',
  LitigationRefund: '诉讼退费',

  // 工具
  AddMonitoringTask: '新增监测任务',
  ViewMonitoringTask: '查看监测任务',
  TaskName: '任务名称',
  MonitoringKeyword: '监测关键字',
  OnlineSearchInput: '任务名称/监测关键字',
  view: '查看',
  Start: '启动',
  StartStatus: '状态启动',
  startTask: '请问是否要启动此任务？',
  monitoringPlatform: '监测平台',
  searchKeyword: '搜索关键字',
  sortMethod: '排序方式',
  defaultSort: '默认排序',
  highToLowPrice: '价格高低',
  requiredKeyword: '必须关键字',
  OnlyTheDataContain:
    '填写该关键字后，至少商品标题中包含该关键字其中一个的数据才会获取到',
  separatedByCommas: '多个关键字用逗号分隔',
  automatically:
    '填写该关键字后，只要商品标题中包含该关键字之一的就会自动排除忽略掉',
  negativeExpression: '设定否词',
  MaximumNumber: '单个平台最大数据条数',
  entries: '请输入100的整数，最小输入100条，最大抓取5000条',
  enterNumbe: '请输入数字',
  enterInteger: '只能输入整数',
  greaterThan100: '请输入大于100的整数',
  cannotExceed5000: '最大数据条数不能超过5000',
  cannotBeEmpty: '任务名称不能为空',
  leastOnePlatform: '至少选择一个平台',
  searchKeywordCannot: '搜索关键字不能为空',
  serialNumber: '序号',
  PlatformType: '平台类型(监测状态)',
  monitorProduct: '监测商品',
  monitorStore: '监测店铺',
  MonitorStartTime: '监测开始时间',
  negation: '否字',
  summary: '汇总',
  product: '商品',
  platformDataStatistic: '平台数据统计',
  priceRangeStatistic: '价格区间统计',
  Top10SellingStore: '销售店铺Top10',
  Top10SellingProduct: '销售商品Top10',
  numberProduct: '商品数',
  price: '价格',
  TaobaoNumber: '淘宝所售品牌商品数',
  TmallNumber: '天猫所售品牌商品数',
  JDComNumber: '京东所售品牌商品数',
  AlibabaNumber: '阿里巴巴所售品牌商品数',
  PinduoduoNumber: '拼多多所售品牌商品数',
  SelectCategory: '选择分类',
  MonitorScope: '监测范围',
  MonitorCategorie: '监测分类',
  CumulativeMonitorCount: '累计监测数量',
  MonitoringStatu: '监测状态',
  MonitoringRetrievalTime: '监控抓取时间',
  PleaseInputkeyword: '请输入关键字',
  image: '图片',
  Type: '类型',
  QuantityGoods: '商品数量',
  MinimumSalesVolume: '最低销量',
  MaximumSalesVolume: '最高销量',
  SalesRange: '销售区间',
  shipment: '发货地',
  SellingPrice: '出售价格',
  Day30SalesVolume: '30天销量',
  oldOnlineMonitor: '线上监测（旧版）',
  // ____

  TaskHall: '任务大厅',
  DoingTask: '在办任务',
  Team: '团队',
  Financ: '财务',
  Riskloan: '风险投',
  ClueTask: '线索发现任务',
  PublicTask: '公共任务',
  DesignateTask: '指派任务',
  CaseTask: '案件打击任务',
  PublicCase: '公共案件',
  DesignateCase: '指派案件',
  Clue: '线索',
  Case: '案件',
  MyTask: '我的任务',
  AllTask: '全部任务',
  MyResult: '我的结果',
  AllResult: '全部结果',
  MyCase: '我的案件',
  Inprogress: '进行中',
  Ended: '已结束',
  AllCase: '全部案件',
  AwaitAllocationCase: '待分配案件',
  MyTransactionCase: '我的出售案件',
  Processing: '出售中',
  Transacted: '已出售',
  AllTransactionCase: '全部出售案件',
  TeamManagement: '人员管理',
  JobPermissions: '职务权限',
  MyCenter: '个人中心',
  ResetPwd: '修改密码',
  Exit: '退出',
  Name: '姓名',
  Sex: '性别',
  Duties: '职务',
  Mail: '电子邮箱',
  Mobile: '手机',
  Operating: '操作',
  AddEmployee: '新增员工',
  editIcon: '编辑',
  prohibitIcon: '禁用',
  resetIcon: '重置密码',
  enableIcon: '启用',
  'name/account/tel': '姓名/账号/手机',
  tortSubjectProperty: {
    P: '身份证号',
    E: '法定代表人',
    I: '经营者'
  },
  isEnable: {
    Y: '启用',
    N: '禁用'
  },
  cancel: '取消',
  reset: '重置',
  sure: '确定',
  forbidUserModal: '确定停用用户吗？',
  resetModal: '确定要重置密码吗？',
  enableModal: '确定启用用户吗？',
  BatchEnableList: {
    Y: '批量启用',
    N: '批量禁用'
  },
  role: {
    All: '全部'
  },
  lawyerList: {
    lawyer: '律师',
    'not-lawyer': '非律师'
  },
  'identity-information': '身份',
  certificateType: {
    IC: '身份证',
    PP: '护照'
  },
  'ID-type': '证件类型',
  tort_type: {
    E_EC: '电商平台',
    S_ST: '实体店铺',
    S_FA: '工厂',
    S_OT: '其他',
    E_WL: '网页链接'
  },
  ec_channel: {
    TT: '淘宝',
    TS: '淘特',
    TM: '天猫',
    AL: '阿里巴巴',
    JD: '京东',
    SN: '苏宁',
    YH: '1号店',
    PD: '拼多多',
    OT: '其他',
    DY: '抖音'
  },

  // 项目状态
  projectState: {
    R: '进行中',
    P: '暂停',
    A: '归档',
    E: '过期'
  },
  // 分配状态
  allocationState: {
    P: '待分配',
    E: '已分配'
  },
  // 核实状态
  verifyState: {
    P: '待核实',
    E: '已核实',
    R: '核实无效'
  },
  CaseState: {
    '1': '已办案',
    '0': '未办案'
  },
  ClueReviewState: {
    C: '待客户确认',
    CP: '客户审核通过',
    CD: '客户审核拒绝'
  },
  // 线索驳回
  ClueReject: {
    A1: '是加盟店',
    A2: '已起诉',
    A3: '资料不完整',
    A4: '正品'
  },
  // 线索通过
  ClueAgree: {
    A1: '不是加盟店',
    A2: '确认为仿品'
  },
  // 民事案件进度
  CivilCaseProgressState: {
    PN: '方案',
    SR: '发函',
    RR: '立案',
    PL: '庭前',
    CG: '庭审',
    JT: '判决',
    EC: '归档',
    TN: '终止',
    AC: '到款',
    EN: '执行',
    RE: '和解',
    ME: '调解',
    WD: '撤诉'

  },
  // 刑事案件进度
  CivilCaseProgressState1: {
    CRAP: '刑事申请',
    RR: '立案',
    INVE: '侦查行动',
    REPR: '审查起诉',
    JT_BB: '判决',
    EC_EC: '归档'
  },
  // 行政案件进度
  CivilCaseProgressState2: {
    ADAP: '行政申请',
    RR: '立案',
    INVE: '侦查行动',
    EC_EC: '归档'
  },
  // 案件类型
  CaseTypeState: {
    online: '线上',
    offline: '线下',
    1: '线下',
    2: '线上'
  },
  // 取证状态
  EvidenceState: {
    P: '待取证',
    W: '待出证',
    A: '已出证'
  },
  // 案件状态
  CaseStates: {
    HH: '进行中',
    TN: '已终止',
    ED: '已结束'
  },
  // 账号状态
  AccountState: {
    false: '禁用',
    true: '启用'
  },
  // 性别
  SexState: {
    F: '女',
    M: '男'
  },
  // 到款状态
  paymentRecordState: {
    P: '待确认',
    E: '已确认'
  },
  // 开票状态
  InvoiceState: {
    P: '开票中',
    E: '开票通过',
    R: '开票驳回'
  },

  // 	审核状态
  ReviewState: {
    '10': '审核中',
    '40': '驳回终止',
    '99': '审核通过'
  },
  // 平台
  onlinePlatformState: {
    '1': '淘宝',
    '2': '天猫',
    '3': '京东',
    '5': '阿里巴巴',
    '6': '拼多多'
  },
  IpState: {
    正常: '正常',
    暂缓: '暂缓',
    终止: '终止',
    未授权: '未授权'
  },

  materialsListState: {
    CM: '项目协作材料',
    EM: '委托材料',
    LD: '诉讼文书模板',
    MM: '主体材料',
    NE: '知名度证据',
    OO: '其它',
    PO: '项目原件',
    RP: '主体材料',
    WD: '在先判决/相关案例',
    WM: '权属材料'
  },
  CaseProgressState: {
    LL: '发函',
    PN_BB: '诉讼方案',
    PN_JC: '材料寄送',
    RR: '立案',
    RR_BB: '递交材料',
    RR_AD: '受理',
    PL: '庭前',
    PL_BB: '传票',
    PL_EE: '证据交换',
    PL_AS: '公告送达',
    PL_OP: '管辖异议',
    PL_PR: '保全',
    CG_CG: '庭审',
    JT_BB: '判决',
    JT_AE: '上诉',
    JT_RP: '应诉',
    CO_CO: '执行',
    CO_SE: '材料寄送',
    CO_RE: '执行结果',
    ST: '到款',
    ST_DL: '到款记录',
    EC_EC: '归档',
    RE_AP: '和解',
    RE_AU: '和解结果',
    ME_AP: '调解',
    ME_AU: '调解结果',
    WD_AP: '撤诉',
    CU_RE: '退费',
    RR_LA: '诉前联调',
    RR_JG: '联调结果',
    WD_AP_RE: '和解撤诉',
    WD_AP_ME: '调解撤诉',
    CO_FI: '执行立案',
    CRAP: '刑事申请',
    MAAP: '材料申请',
    INVE: '侦查行动',
    REPR: '审查起诉',
    ADAP: '行政申请',
    RESU: '结果',
    SUAI: '补充侦查',
    INDI: '起诉结果',
    CC_SI: '刑事二审判决',
    TR_ME: '第三方调解',
    PI: '前期调查',
    CF: '立案阶段',
    AT: '行动阶段',
    PP: '公诉阶段',
    JG: '判决阶段',
    PU: '处罚阶段'
  },
  // 材料类型
  AttachmentState: {
    PA: '授权委托书',
    IT: '起诉书'
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js